// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"BuildControls_BuildControls__1ls82","OrderButton":"BuildControls_OrderButton__3tmKH","enable":"BuildControls_enable__3duzd"};